import { Platform, StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const CategoryListStyle = StyleSheet.create({
    flex: {
        flex: 1,
    },
    plusIconView: {
        alignSelf: "flex-end",
        backgroundColor: appColors.primary,
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        height: 55,
        width: 55,
        position: "absolute",
        bottom: 25,
        right: 25
    },
    deleteIconView2: {
        alignSelf: "flex-end",
        backgroundColor: appColors.red,
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        height: 55,
        width: 55,
        position: "absolute",
        bottom: 25,
        right: 25
    },
    popoverView: {
        flex: 1,
        backgroundColor: appColors.light,
        borderRadius: 8,
        paddingVertical: 5,
        paddingTop: 5
    },
    sortOptions: {
        fontSize: fontSize.smallFontSize,
        paddingHorizontal: 15,
        paddingVertical: 13
    },
    iconStyle: {
        padding: 10,
        backgroundColor: appColors.lightBackgroundColor,
        borderRadius: 10
    }

})